<script lang="ts">
  import Form from "../components/Form.svelte";
  import RadioGroup from "../components/RadioGroup.svelte";
  import SharepointFileInput from "../components/SharepointFileInput.svelte";
  import { domId } from "../lib/dom";
  import Info from "~icons/ph/info";

  let {
    action,
    createUploadSessionUrl,
    uploadAttachmentExtensions,
    errors,
  }: {
    action: string;
    createUploadSessionUrl: string;
    uploadAttachmentExtensions: string[];
    errors: { [key: string]: string } | null;
  } = $props();

  let hasAgreement = $state("yes");

  const closeDialogId = domId("close-dialog")
</script>

<Form method="patch" {action} class="ui-rhythm">
  <h2 class="ui-title">Upload finance agreement</h2>

  <fieldset class="ui-fieldset mb-6">
    <legend>Do you have your finance agreement?</legend>
    <RadioGroup
      name="has_agreement"
      options={[
        ["Yes", "yes"],
        ["No", "no"]
      ]}
      bind:group={hasAgreement}
      required
    />
  </fieldset>

  <div class="ui-content-options">
    <div class:invisible={hasAgreement !== "yes"}>
      <fieldset>
        <div>
          <p class="ui-alert ui-alert-info pb-4 -mb-2.5">If you have a PDF or photos of your finance agreement, it will allow us
            to document many of the key facts about your claim.</p>
          <SharepointFileInput
            name="finance_agreement"
            accept={uploadAttachmentExtensions}
            {createUploadSessionUrl}
            required={hasAgreement === "yes"}
            multiple={true}
          />
        </div>

        {#if errors?.finance_agreement}<div class="ui-error">{errors.finance_agreement}</div>{/if}
        {#if errors?.general}<div class="ui-error">{errors.general}</div>{/if}
      </fieldset>

      <div class="floating-footer">
        <button class="btn btn-ghost" form={closeDialogId}>Cancel</button>
        <button class="btn btn-primary" type="submit" data-viewer-mode>Send</button>
      </div>
    </div>

    <div class="flex flex-col justify-between" class:invisible={hasAgreement === "yes"}>
      <div class="ui-alert ui-alert-info">
        <Info />
        <p>If you can find your finance agreement, it helps us move your case
          forward. If you can't find it, we can still proceed if you
          provide the name of your finance company.</p>
      </div>

      <div class="floating-footer">
        <button class="btn btn-ghost" form={closeDialogId}>Cancel</button>
        <button class="btn btn-primary" type="submit">I don't have it</button>
      </div>
    </div>
  </div>
</Form>

<form method="dialog" id={closeDialogId}></form>
